<template>
  <el-card>
    <div v-if="dateType === 'day' || dateType === 'week' || dateType === 'lastWeek'">
      <el-date-picker
        size='mini'
        style="margin-bottom: .4rem;margin-right: .2rem"
        v-model="nowDateLocal"
        :clearable="false"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        @change="handelDateChange">
      </el-date-picker>
    </div>
    <div v-else>
      <el-date-picker
        style="margin-bottom: .4rem;margin-right: .2rem"
        size="mini"
        v-model="nowDateLocal"
        :clearable="false"
        type="monthrange"
        range-separator="至"
        start-placeholder="开始月份"
        end-placeholder="结束月份"
        value-format="yyyy-MM"
        @change="handelMonthChange">
      </el-date-picker>
    </div>
    <div class="chartBox"  ref="orderBarBox"></div>
  </el-card>
</template>

<script>
var echarts = require('echarts/lib/echarts')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/line')
require('echarts/lib/chart/pie')
export default {
  name: 'OrderBarCard',
  components: {
  },
  props: {
    nowDate: {
      type: Array,
      default: () => {
        return []
      }
    },
    dateType: {
      type: String,
      default: 'day'
    }
  },
  watch: {
    nowDate (val) {
      console.log('wathc now date', val)
      this.nowDateLocal = [...val]
    },
    nowDateLocal (val) {
      this.getOrderBarData()
    }
  },
  computed: {
    orderBarTitle () {
      if (this.dateType === 'day') {
        return '日业绩排行榜'
      } else if (this.dateType === 'month') {
        return '月度业绩排行榜'
      } else if (this.dateType === 'week') {
        return '本周业绩排行榜'
      } else if (this.dateType === 'lastWeek') {
        return '上周业绩排行榜'
      } else {
        return '日业绩排行榜'
      }
    }
  },
  data () {
    return {
      nowDateLocal: [...this.nowDate],
      nowMonthLocal: [],
      orderBarChart: null,
      orderBarHeader: [],
      orderBarData: [],
      orderBarLoading: false
    }
  },
  methods: {
    getOrderBarData () {
      this.$nextTick(() => {
        this.orderBarLoading = true
        this.$axios.get('/api/admin/data_overview/order_bar_data?date=' + this.nowDateLocal, { loadingClose: true })
          .then((res) => {
            const { data } = res
            if (data.code === 0) {
              this.orderBarHeader = data.data.map(item => item.converter.username)
              this.orderBarData = data.data.map(item => item.total_sum)
              this.initCharts()
            }
            this.orderBarLoading = false
          })
      })
    },
    initCharts () {
      this.$nextTick(() => {
        this.orderBarChart = echarts.init(this.$refs.orderBarBox, 'light')
        this.setOrderBarChart()
      })
    },
    setOrderBarChart () {
      let option = {
        title: {
          text: this.orderBarTitle
        },
        color: ['#5787FF'],
        toolbox: {
          show: true,
          showTitle: true,
          feature: {
            saveAsImage: {
              show: true,
              title: '下载'
            },
            magicType: {
              show: true,
              type: ['line', 'bar']
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.orderBarHeader,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '',
            type: 'bar',
            barWidth: '60%',
            data: this.orderBarData
          }
        ]
      }
      this.orderBarChart.setOption(option)
    },
    handelDateChange (val) {
      this.$emit('changeNowDate', val)
    },
    handelMonthChange (val) {
      this.$emit('changeMonthDate', val)
    }
  },
  mounted () {
    console.log('nowDate', this.nowDate)
    // this.initCharts()
  }
}
</script>
<style lang="stylus" scoped>
.chartBox {
  width: 100%;
  height: 6rem;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/data_overview/common/OrderBarCard.vue